import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  theme: "light" | "dark";
  onToggle: () => void;
  variant?: "navbar" | "navbar-light" | "mobile" | "mobile-light";
}

export function ThemeToggle({ theme, onToggle, variant = "navbar" }: ThemeToggleProps) {
  const isDark = theme === "dark";
  const isLight = variant === "navbar-light" || variant === "mobile-light";

  return (
    <button
      onClick={onToggle}
      className={cn(
        "relative flex items-center justify-center rounded-full transition-all duration-300 w-8 h-8",
        isLight
          ? "text-foreground/60 hover:text-foreground border border-border hover:border-primary/30 hover:bg-primary/5"
          : "text-white/60 hover:text-white border border-white/10 hover:border-white/25 hover:bg-white/[0.06]",
        (variant === "mobile" || variant === "mobile-light") && "border-0"
      )}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <motion.div
        key={isDark ? "moon" : "sun"}
        initial={{ scale: 0, rotate: -90, opacity: 0 }}
        animate={{ scale: 1, rotate: 0, opacity: 1 }}
        exit={{ scale: 0, rotate: 90, opacity: 0 }}
        transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      >
        {isDark ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
      </motion.div>
    </button>
  );
}
